import React from 'react';
import Dialog from '@dashboard/components/Dialog';
import { Form } from '@dashboard/components/Formik';
import { useBlockEmail } from '@dashboard/hooks/useBlockedEmails';

const BlockEmailDialog = ({ open, onClose, email, customerId }) => {
  const blockEmail = useBlockEmail({ onSuccess: onClose });

  return (
    <Dialog
      title={`Block ${email}?`}
      cancelButton={null}
      confirmButton={null}
      size="lg"
      open={open}
      onCancel={onClose}
      description="This email will not be able to complete any checkout, event, or form page in your store. Existing subscriptions for this email will continue to renew."
    >
      <Form
        showState={false}
        initialValues={{ email, note: '' }}
        onSubmit={async values => {
          try {
            const data = await blockEmail.mutateAsync({
              email: values.email,
              ...(values.note?.trim() && { note: values.note.trim() }),
              ...(customerId && { customerId }),
            });
            return { data };
          } catch (error) {
            return { error };
          }
        }}
        fields={() => [
          {
            name: 'email',
            label: 'Email address',
            helpText: 'We won’t notify the customer that their email has been blocked.',
            type: 'email',
            required: true,
            disabled: true,
          },
          {
            name: 'note',
            label: 'Reason (optional)',
            type: 'textarea',
            placeholder: 'Add a reason for blocking this email',
            helpText: 'Only you and your team can see this.',
            rows: 3,
          },
        ]}
        formSubmitAlign="end"
        submitButton={{ label: 'Block', appearance: 'primary' }}
        cancelButton={{ label: 'Cancel', appearance: 'secondary', onClick: onClose }}
      />
    </Dialog>
  );
};

export default BlockEmailDialog;
